// import { Link } from "gatsby"
import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"

import "./header.scss"
import MainMenu from "../main-menu/main-menu"
import PopupNotification from "../../atoms/popup-notification/popup-notification"

const Header = props => {
  const {
    setCommondModal,
    setInfoUser,
    mobile,
    notificationState,
    setnotificationState,
    logStatus,
  } = props

  const resultQuery = useStaticQuery(
    graphql`
      query HEADER_QUERY {
        allContentfulNolHome(sort: { fields: titulo, order: ASC }) {
          edges {
            node {
              node_locale
              logoNosotras {
                file {
                  url
                }
                description
              }
              menuNavegacion1
              menuNavegacion2
              menuNavegacion3
              menuNavegacion4
              menuNavegacion5
              menuNavegacion6
            }
          }
        }
        allContentfulNolMenuDeNavegacion(sort: { fields: titulo, order: ASC }) {
          nodes {
            node_locale
            enlaceSubMenu {
              enlaceContenidoSubmenu {
                titulo
                slug
              }
              enlaceTituloSubmenu {
                titulo
                slug
              }
            }
            titulo
          }
        }
      }
    `
  )

  var navSubMenuTitles2 = resultQuery.allContentfulNolMenuDeNavegacion.nodes.filter(
    e => e.node_locale === process.env.LOCALE
  )[0].enlaceSubMenu
  var navSubMenuTitles3 = resultQuery.allContentfulNolMenuDeNavegacion.nodes.filter(
    e => e.node_locale === process.env.LOCALE
  )[2].enlaceSubMenu
  var navSubMenuTitles5 = resultQuery.allContentfulNolMenuDeNavegacion.nodes.filter(
    e => e.node_locale === process.env.LOCALE
  )[1].enlaceSubMenu

  var navegationMenus = {
    navMenu1: resultQuery.allContentfulNolHome.edges.filter(
      e => e.node.node_locale === process.env.LOCALE
    )[0].node.menuNavegacion1,
    navMenu2: resultQuery.allContentfulNolHome.edges.filter(
      e => e.node.node_locale === process.env.LOCALE
    )[0].node.menuNavegacion2,
    navMenu3: resultQuery.allContentfulNolHome.edges.filter(
      e => e.node.node_locale === process.env.LOCALE
    )[0].node.menuNavegacion3,
    navMenu4: resultQuery.allContentfulNolHome.edges.filter(
      e => e.node.node_locale === process.env.LOCALE
    )[0].node.menuNavegacion4,
    navMenu5: resultQuery.allContentfulNolHome.edges.filter(
      e => e.node.node_locale === process.env.LOCALE
    )[0].node.menuNavegacion5,
    navMenu6: resultQuery.allContentfulNolHome.edges.filter(
      e => e.node.node_locale === process.env.LOCALE
    )[0].node.menuNavegacion6,
  }

  const [active_menu, setMenu] = useState("")

  const closeMenu = () => {
    setMenu("")
  }

  const changeMenu = menu => {
    setMenu(menu)
  }

  var logoUrl = resultQuery.allContentfulNolHome.edges.filter(
    e => e.node.node_locale === process.env.LOCALE
  )[0].node.logoNosotras

  return (
    <header>
      {props.modalActive}
      {props.commondModal}
      {notificationState !== null && (
        <PopupNotification
          mobile={mobile}
          notificationState={notificationState}
          setnotificationState={setnotificationState}
        />
      )}

      <MainMenu
        popupLogin={props.popupLogin}
        logout={props.logout}
        isLog={props.isLog}
        logStatus={logStatus}
        infoUser={props.infoUser}
        setInfoUser={setInfoUser}
        logoInfo={logoUrl}
        mobile={props.mobile}
        changeMenu={changeMenu}
        activeMenu={active_menu}
        closeMenu={closeMenu}
        navegationMenus={navegationMenus}
        navSubMenuTitles2={navSubMenuTitles2}
        navSubMenuTitles3={navSubMenuTitles3}
        navSubMenuTitles5={navSubMenuTitles5}
        setCommondModal={setCommondModal}
      />
    </header>
  )
}

export default Header
